import React from 'react';

export function JoinForm({
  attendeeName,
  setAttendeeName,
  introText,
  setIntroText,
  firstTimeVenue,
  setFirstTimeVenue,
  venueName,
  isJoining,
  onJoin,
}) {
  return (
    <div className="mb-6">
      <label
        htmlFor="attendee-name"
        className="mb-2 block text-sm font-medium text-gray-300"
      >
        Your Name <span className="text-red-500">*</span>
      </label>
      <input
        id="attendee-name"
        type="text"
        value={attendeeName}
        onChange={(e) => setAttendeeName(e.target.value)}
        placeholder="Enter your name"
        className="mb-4 w-full rounded-lg border border-gray-700 bg-gray-800 px-4 py-2 text-white placeholder-gray-500 focus:border-[#4ADE80] focus:outline-none focus:ring-2 focus:ring-[#4ADE80]"
        disabled={isJoining}
      />

      <label
        htmlFor="intro-text"
        className="mb-2 block text-sm font-medium text-gray-300"
      >
        Tell us about yourself in one sentence <span className="text-gray-500 text-xs">(optional)</span>
      </label>
      <input
        id="intro-text"
        type="text"
        value={introText}
        onChange={(e) => {
          const value = e.target.value;
          if (value.length <= 100) {
            setIntroText(value);
          }
        }}
        placeholder='e.g., "First-timer at indie shows!" or "Huge fan since their first EP"'
        maxLength={100}
        className="mb-1 w-full rounded-lg border border-gray-700 bg-gray-800 px-4 py-2 text-white placeholder-gray-500 focus:border-[#4ADE80] focus:outline-none focus:ring-2 focus:ring-[#4ADE80]"
        disabled={isJoining}
      />
      {introText.length > 80 && (
        <p className="mb-4 text-right text-xs text-gray-500">
          {introText.length} / 100 characters
        </p>
      )}
      {introText.length <= 80 && <div className="mb-4" />}

      <label className="mb-2 block text-sm font-medium text-gray-300">
        First time at {venueName}? <span className="text-gray-500 text-xs">(optional)</span>
      </label>
      <div className="mb-4 flex gap-4">
        <label className="flex items-center cursor-pointer">
          <input
            type="radio"
            name="first-time-venue"
            checked={firstTimeVenue === true}
            onChange={() => setFirstTimeVenue(true)}
            disabled={isJoining}
            className="mr-2 h-4 w-4 border-gray-700 bg-gray-800 text-[#4ADE80] focus:ring-2 focus:ring-[#4ADE80]"
          />
          <span className="text-sm text-gray-300">Yes</span>
        </label>
        <label className="flex items-center cursor-pointer">
          <input
            type="radio"
            name="first-time-venue"
            checked={firstTimeVenue === false}
            onChange={() => setFirstTimeVenue(false)}
            disabled={isJoining}
            className="mr-2 h-4 w-4 border-gray-700 bg-gray-800 text-[#4ADE80] focus:ring-2 focus:ring-[#4ADE80]"
          />
          <span className="text-sm text-gray-300">No</span>
        </label>
        {firstTimeVenue !== null && (
          <button
            type="button"
            onClick={() => setFirstTimeVenue(null)}
            disabled={isJoining}
            className="text-xs text-gray-500 hover:text-gray-300 underline"
          >
            Clear
          </button>
        )}
      </div>

      <button
        onClick={onJoin}
        disabled={isJoining || !attendeeName.trim()}
        className="w-full rounded-lg bg-[#4ADE80] px-6 py-3 font-semibold text-[#050505] transition-colors hover:bg-[#3bc96a] disabled:cursor-not-allowed disabled:opacity-50"
      >
        {isJoining ? 'Joining...' : 'Join Squad'}
      </button>
    </div>
  );
}
